import { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  width?: number | string;
  height?: number | string;
}

export default function Skeleton(props: Readonly<SkeletonProps>) {
  const { width, height, className, style } = props;

  return (
    <div
      aria-busy="true"
      style={{
        width: width,
        height: height,
        lineHeight: 1,
        ...style,
      }}
      className={twMerge(
        "bg-slate-200 w-full rounded-lg animate-pulse",
        className,
      )}
    />
  );
}
